import Carousel from './includes/Carousel'
import Footer from './includes/Footer'
import Heading from './includes/Heading'

function FansiWin() {
  return (
    <>
      <Heading />
      <Carousel />
      <Footer />
    </>
  )
}

export default FansiWin
